import React from 'react';
import { Box } from '@kohler-dsm-library/kohler-core';
import styles from '../productFeatureCarousel.module.css';

export default function Thumbnails({ images = [], activeIndex, onSelect }) {
  if (!images.length) return null;

  return (
    <Box className={styles.thumbnailRow}>
      {images.map((img, index) => (
        <button
          key={img.image || index}
          className={`${styles.thumbWrapper} ${activeIndex === index ? styles.thumbActive : ''}`}
          onClick={() => onSelect(index)}
          aria-label={`Show image ${index + 1}`}
        >
          <Box className={styles.thumbAspect}>
            <img src={img.image} alt={img.imageAltText || ''} className={styles.thumbImage} />
          </Box>
        </button>
      ))}
    </Box>
  );
}
